import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioArch71 } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_ARCH_71: TIdToPageConfigMap = {
  [PageIdStylioArch71.SUBSCRIPTIONS_ARCH_71]: {
    id: PageIdStylioArch71.SUBSCRIPTIONS_ARCH_71,
  },
  [PageIdStylioArch71.SUB_UPSELL_ARCH_71]: {
    id: PageIdStylioArch71.SUB_UPSELL_ARCH_71,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArch71.FACE_STYLING_PDF_UPSELL_ARCH_71]: {
    id: PageIdStylioArch71.FACE_STYLING_PDF_UPSELL_ARCH_71,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArch71.PROPORTIONS_PDF_UPSELL_ARCH_71]: {
    id: PageIdStylioArch71.PROPORTIONS_PDF_UPSELL_ARCH_71,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioArch71.DOWNLOAD_ARCH_71]: {
    id: PageIdStylioArch71.DOWNLOAD_ARCH_71,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
